export default __webpack_public_path__ + "static/0114-c71ef9ded7e846b5b7ff494f03d8da4c.png";